<div [attr.class]="'btn type-' + type + (disabled ? ' disabled' : '')">
    <div class="text" qa="text">
        {{text}}
        <i *ngIf="type === ButtonType.RightArrow" class="fa fa-angle-right"></i>
    </div>
</div>
